import Routes from 'constants/Routes';
import useGlobalSettings from 'hooks/useGlobalSettings';
import useHasAccessToRoutePlanningSettings from 'hooks/useHasAccessToRoutePlanningSettings';
import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Skyddar fliken Inställningar → Ruttplanering, inte bara menyvalet: den som skriver in adressen
 * utan att stå i listan (GlobalSetting 116) ska få 404, inte en sida där anropen svarar 403.
 * Samma mönster som RequireRiddermarkReportingAccess.
 */
const RequireRoutePlanningSettingsAccess: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => {
  const hasAccess = useHasAccessToRoutePlanningSettings();
  const { loaded, isError } = useGlobalSettings();

  // Vänta in inställningarna — hooken svarar false tills de kommit. Ett fel behandlas som
  // "ingen tillgång": hellre fel sida än en permanent tom sida.
  if (!loaded) {
    return isError ? <Navigate replace to={Routes.notFound} /> : null;
  }

  if (!hasAccess) {
    return <Navigate replace to={Routes.notFound} />;
  }

  return children;
};

export default RequireRoutePlanningSettingsAccess;
